import { useCallback } from "react"
import { useQuery, useQueryClient } from "@tanstack/react-query"

import { useGetImdf } from "../useGetImdf"
import { useGetPosts } from "./useGetPosts"
import { Post, PostData } from "../../../types"
import { preparePostData } from "./utils/preparePostData"

export const useGetPost = (id) => {
  const queryClient = useQueryClient()
  const { data: imdfData } = useGetImdf()
  const { isFetched } = useGetPosts()
  const findOne = useCallback(
    (id) => imdfData.features.find((f) => f.id === id),
    [imdfData]
  )
  return useQuery<Post | undefined, unknown, PostData>({
    queryKey: ["posts", id],
    queryFn: async () => {
      const posts: Post[] = queryClient.getQueryData(["posts"]) || []
      const post = posts.find((post) => post.id === id)
      return Promise.resolve(post)
    },
    select: (post) => preparePostData(post, findOne),
    staleTime: 0,
    enabled: isFetched,
  })
}
